
<template>
  <page-layout
    :breadcrumbs="[
      {
        text: $t('pages.home'),
        disabled: true,
        exact: true
      }
    ]"
    :title="$t('pages.comercializacionDigital')"
  >
    <v-layout row justify-center>
      <v-flex xl8>
        <v-container grid-list-xl mt-3 pa-0 style="margin-bottom:10px">
          <v-layout row wrap justify-center>
            <v-flex
              xs12 sm8 md6 xl5
              v-for="accion in acciones"
              :key="accion.titulo"
              d-flex
            >
              <v-card class="pointer" @click="$router.push({name: accion.ruta})">
                <o-tint-img :src="accion.src"/>
                <v-card-title class="pb-0">
                    <v-icon
                      left
                      color="primary"
                      class="custom-icon"
                    >
                      {{accion.icon}}
                    </v-icon>
                  <h3 class="primary--text headline">{{accion.titulo}}</h3>
                </v-card-title>
                <v-card-text>
                  <span class="grey--text">{{accion.desc}}</span>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-footer absolute class="secondary" style="height:20px;min-height:20px;padding-right:8px">
          <v-spacer></v-spacer>
          <span class="caption primary--text">{{$t('reservas.listas.revisionBackEnd')}}{{versionApi}} {{$t('reservas.listas.revisionFrontEnd')}}{{version}}</span>
        </v-footer>
      </v-flex>
    </v-layout>
  </page-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      version: 'version',
      versionApi: 'versionApi',
      usuario: 'login/usuario'
    }),
    acciones () {
      return [
        {
          titulo: this.$t('pages.reservas.reservasMayuscula'),
          desc: this.$t('pages.reservas.reservasTexto'),
          ruta: 'reservas.list',
          src: require('@/assets/images/home/reservas.png'),
          icon: 'icon-reservas'
        },
        {
          titulo: this.$t('pages.equipoComercialMayuscula'),
          desc: this.$t('pages.equipoComercialTexto'),
          ruta: 'comerciales.list',
          src: require('@/assets/images/home/comerciales.png'),
          icon: 'icon-proveedores'
        },
        {
          titulo: this.$t('pages.promocionesMayuscula'),
          desc: this.$t('pages.promocionesTexto'),
          ruta: 'promociones.list',
          src: require('@/assets/images/home/promociones.png'),
          icon: 'mdi-home-city'
        },
        {
          titulo: this.$t('pages.configuracion.configuracionMayuscula'),
          desc: this.$t('pages.configuracion.configuracionTexto'),
          ruta: 'configuracion',
          src: require('@/assets/images/home/configuracion.png'),
          icon: 'icon-settings'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue